import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class Config {
//  kundenId:string =  '99991';
 kundenId:string =  '9';
 dataBaseUrl:string = "https://dev2.maereo.de/backend/api";
}
